import { NgModule,APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SalesRoutingModule } from './sales-routing.module';
import { SalesComponent } from './sales.component';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MaterialModule } from '../material.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { GridModule } from '@progress/kendo-angular-grid';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { HttpClientModule } from "@angular/common/http";
import { MaintainWatchComponent } from './maintain-watch/maintain-watch.component';
import { GeneralDashComponent } from './general-dash/general-dash.component';
import { GeneralDashSearchRangeComponent } from './general-dash-search-range/general-dash-search-range.component';
import { CreamsDashComponent } from './creams-dash/creams-dash.component';
import { MHDashComponent } from './mh-dash/mh-dash.component';
import { TimeSheetDashComponent } from './timesheet-dash/timesheet-dash.component';
import { ListWatchComponent } from './list-watch/list-watch.component';
import { GeneralOverviewComponent } from './general-overview/general-overview.component';
import { LastSevenDaysComponent } from './last-seven-days/last-seven-days.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';

@NgModule({
  imports: [
    CommonModule,
    SalesRoutingModule,
    MaterialModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    MatGridListModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatRippleModule,
    MatDialogModule,
    //DatePipe,
    NgxSpinnerModule,
    GridModule,
    DropDownsModule,
    ButtonsModule,
    DateInputsModule,
    LayoutModule,
    PDFExportModule,
    ExcelExportModule,
    DialogsModule,
    UploadsModule,
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    //MaintainWatchComponent,
    NgxChartsModule
  ],
  declarations: [SalesComponent,
    MaintainWatchComponent,
    GeneralDashComponent,
    GeneralDashSearchRangeComponent,
    CreamsDashComponent,
    MHDashComponent,
    TimeSheetDashComponent,
    ListWatchComponent,
    GeneralOverviewComponent,
    LastSevenDaysComponent
  ]
})
export class SalesModule { }
